import React, { useMemo, useCallback } from "react";
import { useFormikContext } from "formik";
import { useTheme } from "styled-components";
import { Col } from "components/bootstrap";
import { FormikInput } from "components/common";
import ColorConfigurationPopover from "views/components/aggregationwizard/ColorConfigurationPopover";
import { getDefaultLabelColor } from "views/components/visualizations/utils/getDefaultPlotFontSettings";
const AxisVisualizationField = ({ name, field, title, inputHelp }) => {
  const theme = useTheme();
  const { values, setFieldValue } = useFormikContext();
  const curColor = useMemo(() => {
    var _a, _b, _c;
    const visualizationConfig = values.visualization.config;
    const defaultColor = getDefaultLabelColor(theme);
    if ("axisConfig" in visualizationConfig) {
      return (_c = (_b = (_a = visualizationConfig == null ? void 0 : visualizationConfig.axisConfig) == null ? void 0 : _a[field.id]) == null ? void 0 : _b.color) != null ? _c : defaultColor;
    }
    return defaultColor;
  }, [field.id, theme, values.visualization.config]);
  const onColorSelect = useCallback(
    (color) => {
      setFieldValue(`${name}.color`, color);
    },
    [name, setFieldValue]
  );
  const validateField = useCallback(
    (value) => {
      const axisConfig = "axisConfig" in values.visualization.config ? values.visualization.config.axisConfig : {};
      const hasError = "showAxisLabels" in values.visualization.config && values.visualization.config.showAxisLabels && !Object.values(axisConfig).some(({ color, title: axisTitle }) => color != null ? color : axisTitle) && !value;
      if (hasError) return "At least for one axis should be defined label or color.";
      return null;
    },
    [values.visualization.config]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      id: `${name}.title-input`,
      label: title,
      bsSize: "small",
      placeholder: field.description,
      name: `${name}.title`,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-8",
      formGroupClassName: "",
      help: inputHelp,
      validate: validateField
    }
  ), /* @__PURE__ */ React.createElement(Col, { sm: 1 }, /* @__PURE__ */ React.createElement(
    ColorConfigurationPopover,
    {
      title: `Color configuration for ${field.title}`,
      curColor,
      onColorSelect
    }
  )));
};
export default AxisVisualizationField;
